import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, Divider } from '@material-ui/core';
import { getCodeEditStatus } from '../../../store/global/selectors';
import { invokePostService, invokeGetService, setReRender, handleSnackBar, setCodeEditStatus } from "../../../store/global/actions";


export default function DeleteHandler({ id, onClose, onCompletion, handlerType, category, element, handlerAssociatedEvent }) {

    const dispatch = useDispatch();
    const codeEditStatus = useSelector(getCodeEditStatus);
    let [selectedHandler, setSelectedHandler] = useState(undefined);
    let [loading, setLoading] = useState(false);
    useEffect(() => {

        let eId = handlerAssociatedEvent != undefined ? handlerAssociatedEvent._id : id;
        let cId = (handlerType === 'onsend') ? element.item.src : element.item.dst;
        let type = handlerType;
        dispatch(invokeGetService('getEventHandler', [eId, cId, type]))
            .then((response) => {
                setSelectedHandler(response.data)
            });

    }, [])
   

    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteHandler', {}, [selectedHandler?._id]))
            .then((response) => {
                setLoading(false);
                if (codeEditStatus) {
                    dispatch(setCodeEditStatus(false));
                }
                if (response.status) {
                    dispatch(setReRender());
                    onCompletion('Handler', 'delete')
                }
                else {
                    dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
                }
            })
    }

    return (
        <Grid container direction={"row"} spacing={1} className={"deleteDialogBox"} >
            <Grid item xs={12}>
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete the Handler? </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <Button color="primary" variant="outlined" style={{ marginLeft: 10 }} onClick={onClose} >Cancel</Button>
                <Button color="secondary" disabled={selectedHandler === undefined || loading} variant="contained" style={{ marginLeft: 10}} onClick={onDelete} >Delete</Button>
            </Grid>

        </Grid>

    )
}